import { render, staticRenderFns } from "./transitionPage.html?vue&type=template&id=12ab0646&scoped=true&"
import script from "./transitionPage.js?vue&type=script&lang=js&"
export * from "./transitionPage.js?vue&type=script&lang=js&"
import style0 from "./transitionPage.scss?vue&type=style&index=0&id=12ab0646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ab0646",
  null
  
)

export default component.exports